import { db } from "./firebase";
import { collection, addDoc, getDocs, doc, getDoc, setDoc } from "firebase/firestore";

/* ---------------- SAVE FOOD EVENT ---------------- */

export const saveEvent = async (event) => {
  await addDoc(collection(db, "events"), event);
};

/* ---------------- GET COMMUNITY DATA ---------------- */

export const getCommunity = async () => {
  const snapshot = await getDocs(collection(db, "community"));

  const data = {};

  snapshot.forEach((docSnap) => {
    data[docSnap.id] = docSnap.data();
  });

  return data;
};

/* ---------------- UPDATE COMMUNITY ---------------- */

export const updateCommunity = async (food, suggestions) => {
  const ref = doc(db, "community", food.toLowerCase());
  const snap = await getDoc(ref);

  let existing = snap.exists() ? snap.data() : {};

  suggestions.forEach((item) => {
    existing[item] = (existing[item] || 0) + 1;
  });

  await setDoc(ref, existing);
};

/* ---------------- PROFILE ---------------- */

export const saveProfile = async (userId, profile) => {
  await setDoc(doc(db, "users", userId), profile);
};

export const getProfile = async (userId) => {
  const snap = await getDoc(doc(db, "users", userId));
  return snap.exists() ? snap.data() : null;
};

/* ---------------- FEEDBACK ---------------- */

export const saveFeedback = async (feedback) => {
  await addDoc(collection(db, "feedback"), feedback);
};
